import { useState } from "react";

export const useAdminFormModal = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	const isEditing = Boolean(selectedItem?.id);

	const openCreate = () => {
		setSelectedItem(null);
		setIsOpen(true);
	};

	const openEdit = item => {
		setSelectedItem(item || null);
		setIsOpen(true);
	};

	const close = () => {
		setIsOpen(false);
		setSelectedItem(null);
	};

	return {
		isOpen,
		selectedItem,
		isEditing,
		openCreate,
		openEdit,
		close
	};
};